import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Award, BookOpen, Briefcase, Lightbulb } from 'lucide-react';
const About: React.FC = () => {
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-317">
      {/* Hero Section */}
      <section className="bg-blue-600 text-white py-16" data-id="element-318">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-319">
          <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-320">
            About GoABitFurther Africa
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto" data-id="element-321">
            Empowering Education Students to Discover Modern Career
            Possibilities
          </p>
        </div>
      </section>
      {/* Mission Section */}
      <section className="py-16" data-id="element-322">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-324">
            <div data-id="element-325">
              <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-326">
                Our Mission
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-327">
                GoABitFurther Africa exists to bridge the gap between education
                degrees and the diverse career opportunities available to
                graduates. We believe that education students across Africa
                deserve to know the full potential of their degrees beyond
                traditional teaching roles.
              </p>
              <p className="text-lg text-gray-600 mb-6" data-id="element-328">
                Our mission is to empower education students and recent
                graduates with the knowledge, skills, and connections they need
                to explore and succeed in alternative career paths that value
                their unique educational expertise.
              </p>
              <div className="flex space-x-4" data-id="element-329">
                <Link to="/courses" className="px-6 py-3 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition-colors" data-id="element-330">
                  Explore Career Paths
                </Link>
              </div>
            </div>
            <div data-id="element-331">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ce4SprZCP8oJeCYJAFD1iS/mainpage.jpg" alt="Education students collaborating" className="rounded-lg shadow-xl" data-id="element-332" />
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="py-16 bg-white" data-id="element-333">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-334">
          <div className="text-center mb-16" data-id="element-335">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-336">
              Our Values
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-337">
              These core principles guide everything we do at EducPath Africa.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-338">
            <div className="bg-blue-50 p-8 rounded-lg text-center" data-id="element-339">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-340">
                <Lightbulb className="text-blue-600" size={28} data-id="element-341" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-342">
                Possibility Thinking
              </h3>
              <p className="text-gray-600" data-id="element-343">
                We believe in expanding horizons and helping education students
                see the full range of possibilities their degree offers them in
                the modern workplace.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg text-center" data-id="element-344">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-345">
                <Users className="text-blue-600" size={28} data-id="element-346" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-347">
                Community Connection
              </h3>
              <p className="text-gray-600" data-id="element-348">
                We foster a supportive community where education graduates can
                connect, share experiences, and learn from those who have
                successfully transitioned to alternative careers.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg text-center" data-id="element-349">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-350">
                <Briefcase className="text-blue-600" size={28} data-id="element-351" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-352">
                Practical Application
              </h3>
              <p className="text-gray-600" data-id="element-353">
                We focus on providing practical, actionable guidance that helps
                education graduates translate their academic knowledge into
                valuable workplace skills.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Team Section */}
      <section className="py-16" data-id="element-354">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-355">
          <div className="text-center mb-16" data-id="element-356">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-357">Our Team</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-358">
            <div className="bg-white shadow-sm rounded-lg overflow-hidden" data-id="element-359">
              <img src="https://goabitfurtherafrica.site/wp-content/uploads/2022/05/IMG-20220522-WA0034-1-1024x1024.jpg" alt="Team Member" className="w-full h-64 object-cover object-center" data-id="element-360" />
              <div className="p-6" data-id="element-361">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-362">
                  Ikponmwosa Aiwekhoe
                </h3>
                <p className="text-blue-600 mb-4" data-id="element-363">Founder & CEO</p>
                <p className="text-gray-600 text-sm" data-id="element-364">
                  Passionate about creating opportunities for education
                  graduates in Africa to explore diverse career paths beyond
                  traditional teaching roles.
                </p>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded-lg overflow-hidden" data-id="element-365">
              <img src="https://goabitfurtherafrica.site/wp-content/uploads/2022/05/IMG-20220522-WA0039-1-1024x1024.jpg" alt="Team Member" className="w-full h-64 object-cover object-center" data-id="element-366" />
              <div className="p-6" data-id="element-367">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-368">
                  Adeola Adeyemo
                </h3>
                <p className="text-blue-600 mb-4" data-id="element-369">Operations Director</p>
                <p className="text-gray-600 text-sm" data-id="element-370">
                  Education professional with expertise in program development
                  and implementation, ensuring our initiatives deliver
                  measurable impact.
                </p>
              </div>
            </div>
            <div className="bg-white shadow-sm rounded-lg overflow-hidden" data-id="element-371">
              <img src="https://goabitfurtherafrica.site/wp-content/uploads/2022/05/IMG-20220522-WA0042-1024x1024.jpg" alt="Team Member" className="w-full h-64 object-cover object-center" data-id="element-372" />
              <div className="p-6" data-id="element-373">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-374">
                  Olajumoke Ogunleye
                </h3>
                <p className="text-blue-600 mb-4" data-id="element-375">
                  Career Development Specialist
                </p>
                <p className="text-gray-600 text-sm" data-id="element-376">
                  Helps education graduates identify and develop the skills
                  needed to succeed in alternative career paths through
                  personalized guidance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Impact Section */}
      <section className="py-16 bg-blue-600 text-white" data-id="element-377">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-378">
          <div className="text-center mb-16" data-id="element-379">
            <h2 className="text-3xl font-bold mb-4" data-id="element-380">Our Impact</h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto" data-id="element-381">
              We're proud of the difference we're making in education graduates'
              career journeys across Africa.
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-382">
            <div className="text-center" data-id="element-383">
              <div className="text-4xl font-bold mb-2" data-id="element-384">3,500+</div>
              <p className="text-blue-100" data-id="element-385">Students & Graduates Served</p>
            </div>
            <div className="text-center" data-id="element-386">
              <div className="text-4xl font-bold mb-2" data-id="element-387">10</div>
              <p className="text-blue-100" data-id="element-388">Career Paths Explored</p>
            </div>
            <div className="text-center" data-id="element-389">
              <div className="text-4xl font-bold mb-2" data-id="element-390">78%</div>
              <p className="text-blue-100" data-id="element-391">Successful Career Transitions</p>
            </div>
            <div className="text-center" data-id="element-392">
              <div className="text-4xl font-bold mb-2" data-id="element-393">15</div>
              <p className="text-blue-100" data-id="element-394">African Countries Reached</p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-white" data-id="element-395">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-396">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-397">
            Ready to Explore New Possibilities?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-398">
            Join our community of education students and graduates who are
            discovering the full potential of their degrees.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-399">
            <Link to="/signup" className="px-8 py-3 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition-colors" data-id="element-400">
              Start Your Journey
            </Link>
            <Link to="/contact" className="px-8 py-3 border border-blue-600 text-blue-600 rounded-md font-semibold hover:bg-blue-50 transition-colors" data-id="element-401">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default About;